import { EVENT_ONBOARDING, ONBOARDING_SUCCESS } from 'constants/uTagConstants/RAConstants';
import { getLanguage } from 'core/i18n';
import { FIRST_OWNER } from 'constants/holders/holderTypes';
import { AUTHORIZED, COOWNER } from 'constants/jointHolders/holderTypes';
import {
    INTERACTION_TYPES,
    PROCESS_TYPE,
    SECTION_CATEGORY,
    SECTION_FAMILY,
    SECTION_NAME,
    SERVICE_TYPE,
} from 'constants/uTagConstants/ga4';
import { getGA4EventKeys } from 'utilities/ga4';

const Storage = require('utilities/storage');
const Device = require('mobile-detect');
const StringHelper = require('utilities/stringHelper');

const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const { LOCAL_ENVIRONMENT } = require('constants/index');
const { PATH_CONTACT, PATH_CREATE_NEW_CLIENT, PATH_OPEN_YOUR_ACCOUNT } = require('constants/uTagConstants/paths');
const tools = require('utilities/tools');
const EVENT_ACTION_PROMO_CODE = 'codigo promocional';

const ARES_PRODUCT_ID = ['143.808'];
const ARES_PRODUCT_NAME = ['143.808'];
const ARES_PRODUCT_CATEGORY = ['loans'];
const DOCUMENTATION_PRODUCT_NAME = '500.802.er0000014';

const RELIABLE = {
    iban: 'iban',
    postOffice: 'correo',
    courier: 'mensajero',
    videoCall: 'videoconferencia',
    videocall: 'videoconferencia',
    'unassisted-videocall': 'videoselfie',
    unassisted_videocall: 'videoselfie',
    videoSelfie: 'videoselfie',
};

const PAGE_GENERIC = 'pagina generica';
const PAGE_PRODUCT = 'pagina de producto';
const PAGE_INITIAL = 'pagina de inicio';
const PAGE_ERROR = 'pagina de error';

const VIDEOCALL_IDENTIFICATION = 'validacion por videollamada';
const VIDEOSELFIE_IDENTIFICATION = 'validacion por videoselfie';

const holderTypes = {
    [FIRST_OWNER]: 'firstTitular',
    [COOWNER]: 'secondTitular',
    [AUTHORIZED]: 'authorised',
};

let isRecordedInitialPage = false;
let isFinalizedIdentityVerification = false;
let isClickedVideoSelected = false;
let isFinalizedContract = false;
let isFinalized = false;
let isRecordedAddJointHoldersPage = false;
let isRecordedJointHoldersConfirmationPage = false;
let ipClient = '';
let divisaderoTime = 1000;
let isRecordedTestSuccess = false;
let isRecordedTestFailure = false;
let isRecordedProfileInvestmentPlan = false;

const getIpClient = callBack => {
    if (ipClient === '') {
        Api.get(apiURLBuilder.getURL('getIpClient')).then(
            function (response) {
                ipClient = response.body.ip;
                callBack(ipClient);
            },
            function () {}
        );
    } else {
        callBack(ipClient);
    }
};

const parseDataLayer = (dataLayer, whitelist) => {
    let i, len, prop;
    const parsedDataLayer = {};
    if (!dataLayer || typeof dataLayer !== 'object' || !whitelist || !whitelist.length) {
        return parsedDataLayer;
    }
    for (i = 0, len = whitelist.length; i < len; i += 1) {
        prop = whitelist[i];
        try {
            parsedDataLayer[prop] = dataLayer[prop];
        } catch (e) {
            return { description: 'Onboarding parseDataLayer failed' };
        }
    }

    return parsedDataLayer;
};

const logOnboardingDataLayer = () => {
    const dataLayer_onboarding = window.utag_data;
    try {
        if (typeof dataLayer_onboarding !== 'undefined') {
            const dLWhitelist = [
                'estadoUsuario',
                'intervinientes',
                'pasoProceso',
                'productoOnboarding',
                'productoOnboardingDetalle',
                'tipoPagina',
                'tipoProceso',
                'tipoTitular',
                'tipoUsuario',
                'tipoUsuarioInterviniente',
                'onboardingPromoCode',
                'nombrePagina',
                'categoriaError',
                'estadoError',
                'numeroError',
                'descripcionError',
                'identificadorOnboarding',
                'tipoOnboarding',
            ];

            return { description: 'Onboarding Datalayer', value: parseDataLayer(dataLayer_onboarding, dLWhitelist) };
        }
    } catch (e) {
        return { description: 'Onboarding DATALAYER Parsing Module Failed', error: e };
    }
};

const sendTag = (link, data) => {
    const uTagHidden = Storage.cookies.get('uTagHidden');
    if (!uTagHidden) {
        if (link) {
            window.utag.link({ ...window.utag_data, ...data } || window.utag_data);
        } else {
            window.utag.view(data || window.utag_data);
            // PASO 1-6 / con cada pageview virtual
            if (
                typeof window.TLT !== 'undefined' &&
                typeof window.TLT.isInitialized === 'function' &&
                window.TLT.isInitialized()
            ) {
                window.TLT.logCustomEvent('Onboarding Datalayer', logOnboardingDataLayer());
            }
        }
    }
};

const doTagging = (gaTags, link = false) => {
    getIpClient(function (ip) {
        if (__ENV__ === LOCAL_ENVIRONMENT) return;

        gaTags.ipUsuario = ip;
        gaTags.segmentoUsuario = 'particular';
        gaTags.zonaWeb = 'onboarding';

        const md = new Device(navigator.userAgent);
        let deviceType = 'desktop';
        if (md.tablet() != null) {
            deviceType = 'tablet';
        } else if (md.tablet() != null || md.phone() != null) {
            deviceType = 'mobile';
        }

        gaTags.versionSitio = deviceType;
        gaTags.idioma = getLanguage();
        const result = { ...gaTags };

        if (divisaderoTime === 0) {
            sendTag(link, result);
        } else {
            setTimeout(function () {
                sendTag(link, result);
                divisaderoTime = 0;
            }, divisaderoTime);
        }
    });
};

const getDataProcess = pathForTag => {
    const _pathForTag = StringHelper.stringReplaceAll(pathForTag, '-', ' ');
    const dataProcess = _pathForTag.split('/');

    let detalleProceso = '';
    for (let i = 3; i < dataProcess.length; i++) {
        if (dataProcess[i] !== '') detalleProceso = `${dataProcess[i]} `;
    }

    const returnData = {
        tipoProceso: dataProcess[1],
        pasoProceso: dataProcess[2],
        detalleProceso: detalleProceso.trim(),
    };

    return returnData;
};

const recordedInitialPage = (recorded = true) => {
    isRecordedInitialPage = recorded;
};

const getRecordedInitialPage = () => {
    return isRecordedInitialPage;
};

const recordedTestSuccess = (recorded = true) => {
    isRecordedTestSuccess = recorded;
};

const getRecordedTestSuccess = () => {
    return isRecordedTestSuccess;
};

const recordedTestFailure = (recorded = true) => {
    isRecordedTestFailure = recorded;
};

const getRecordedTestFailure = () => {
    return isRecordedTestFailure;
};

const recordedProfileInvestmentPlan = (recorded = true) => {
    isRecordedProfileInvestmentPlan = recorded;
};

const getRecordedProfileInvestmentPlan = () => {
    return isRecordedProfileInvestmentPlan;
};

const recordedAddJointHoldersPage = (recorded = true) => {
    isRecordedAddJointHoldersPage = recorded;
};

const getRecordedAddJointHoldersPage = () => {
    return isRecordedAddJointHoldersPage;
};

const recordedJointHoldersConfirmationPage = (recorded = true) => {
    isRecordedJointHoldersConfirmationPage = recorded;
};

const getRecordedJointHoldersConfirmationPage = () => {
    return isRecordedJointHoldersConfirmationPage;
};

const recordedFinalizedIdentityVerification = () => {
    isFinalizedIdentityVerification = true;
};

const recordedVideoSelected = clicked => {
    isClickedVideoSelected = clicked;
};

const getRecordedVideoSelected = () => {
    return isClickedVideoSelected;
};

const getFinalizedIdentityVerification = () => {
    return isFinalizedIdentityVerification;
};

const recordedFinalizedContract = () => {
    isFinalizedContract = true;
};

const getFinalizedContract = () => {
    return isFinalizedContract;
};

const recordedFinalized = () => {
    isFinalized = true;
};

const getFinalized = () => {
    return isFinalized;
};

const recordInitialPage = (
    pathForTag,
    product = '8000000',
    detalleProducto,
    jointHolderAccount = null,
    investmentType,
    nombreProducto,
    identificadorOnboarding
) => {
    const onboardingPromoCode = '';
    let isJointHolderAccount = '';
    let typeHolder = '';
    let typeUserHolder = '';
    let onboardingHolderType = '';
    if (jointHolderAccount) {
        isJointHolderAccount = jointHolderAccount.isJointHolderAccount;
        typeHolder = jointHolderAccount.typeHolder;
        typeUserHolder = jointHolderAccount.typeUserHolder;
        onboardingHolderType = holderTypes?.[typeHolder];
    }

    doTagging({
        nombrePagina: pathForTag,
        tipoPagina: PAGE_INITIAL,
        estadoUsuario: 'no logado',
        idExpedienteOnboarding: '',
        identificadorUsuario: '',
        productoOnboarding: product,
        productoOnboardingDetalle: detalleProducto,
        idFehaciente: '',
        tiempoCompletarOnboarding: '',
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        onboardingPromoCode,
        tipoProceso: 'onboarding',
        pasoProceso: 'abre tu cuenta',
        detalleProceso: '',
        tipoUsuario: 'no cliente',
        intervinientes: isJointHolderAccount,
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: typeUserHolder,
        tipoOnboarding: investmentType,
        nombreProducto,
        devId: '1recordInitialPage',
        processStep: 'step1',
        identificadorOnboarding,
        ...getGA4EventKeys({
            eventName: 'step_register',
            pageName: '/onboarding/step1/register',
            processDetail: 'register',
            onboardingType: investmentType,
            onboardingHolderType,
        }),
    });
};

const recordPage = (
    pathForTag,
    recordId,
    userId,
    product,
    detalleProducto,
    promoCode = '',
    jointHolderAccount = [],
    reliableId = '',
    timeComplete = '',
    tipoOnboarding = '',
    customProcess = {}
) => {
    const onboardingPromoCode = promoCode === '' ? 'sin codigo promocional' : promoCode;
    let isJointHolderAccount = jointHolderAccount.isJointHolderAccount ?? '';
    isJointHolderAccount = pathForTag === PATH_CONTACT ? '' : isJointHolderAccount;
    const typeHolder = jointHolderAccount.typeHolder ?? '';
    const typeUserHolder = jointHolderAccount.typeUserHolder ?? '';
    const onboardingHolderType = holderTypes?.[typeHolder] ?? '';
    const isCustomEmpty = tools.isEmptyObject(customProcess);
    const dataProcess = isCustomEmpty ? getDataProcess(pathForTag) : customProcess;
    const options = {
        nombrePagina: pathForTag,
        tipoPagina: PAGE_PRODUCT,
        estadoUsuario: 'logado',
        idExpedienteOnboarding: recordId,
        identificadorUsuario: userId,
        productoOnboarding: product,
        productoOnboardingDetalle: detalleProducto,
        idFehaciente: reliableId,
        tiempoCompletarOnboarding: timeComplete,
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        tipoOnboarding,
        onboardingPromoCode,
        onboardingHolderType,
        tipoProceso: dataProcess.tipoProceso,
        pasoProceso: dataProcess.pasoProceso,
        detalleProceso: dataProcess.detalleProceso,
        tipoUsuario: 'no cliente',
        intervinientes: isJointHolderAccount,
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: typeUserHolder,
        devId: '1recordPage',
    };

    doTagging({ ...options, ...dataProcess });
};

const recordRAPage = (
    pathForTag,
    nombreProducto = '',
    recordId,
    userId,
    product,
    detalleProducto,
    promoCode = '',
    jointHolderAccount = [],
    reliableId = '',
    timeComplete = '',
    tipoOnboarding = '',
    onboardingOrigin = ''
) => {
    const onboardingPromoCode = promoCode === '' ? 'sin codigo promocional' : promoCode;
    const dataProcess = getDataProcess(pathForTag);
    let isJointHolderAccount = jointHolderAccount.isJointHolderAccount ?? '';
    isJointHolderAccount = pathForTag === PATH_CONTACT ? '' : isJointHolderAccount;
    const typeHolder = jointHolderAccount.typeHolder ?? '';
    const typeUserHolder = jointHolderAccount.typeUserHolder ?? '';
    const onboardingHolderType = holderTypes?.[typeHolder] ?? '';

    doTagging({
        nombrePagina: pathForTag,
        tipoPagina: PAGE_PRODUCT,
        estadoUsuario: 'logado',
        idExpedienteOnboarding: recordId,
        identificadorUsuario: userId,
        productoOnboarding: product,
        productoOnboardingDetalle: detalleProducto,
        idFehaciente: reliableId,
        tiempoCompletarOnboarding: timeComplete,
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        tipoOnboarding,
        onboardingPromoCode,
        tipoProceso: dataProcess.tipoProceso,
        pasoProceso: dataProcess.pasoProceso,
        detalleProceso: dataProcess.detalleProceso,
        nombreProducto,
        tipoUsuario: 'no cliente',
        intervinientes: isJointHolderAccount,
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: typeUserHolder,
        devId: '1RAPage',
        onboardingHolderType,
        onboardingOrigin,
    });
};

const recordRoboGBIPage = (
    pathForTag,
    tipoProceso,
    pasoProceso,
    detalleProceso = '',
    recordId,
    userId,
    product,
    detalleProducto,
    promoCode = '',
    jointHolderAccount = [],
    reliableId = '',
    timeComplete = '',
    investmentType = ''
) => {
    const onboardingPromoCode = promoCode === '' ? 'sin codigo promocional' : promoCode;
    let isJointHolderAccount = jointHolderAccount.isJointHolderAccount ?? '';
    isJointHolderAccount = pathForTag === PATH_CONTACT ? '' : isJointHolderAccount;
    const typeHolder = jointHolderAccount.typeHolder ?? '';
    const typeUserHolder = jointHolderAccount.typeUserHolder ?? '';

    doTagging({
        nombrePagina: pathForTag,
        tipoPagina: PAGE_PRODUCT,
        estadoUsuario: 'logueado',
        idExpedienteOnboarding: recordId,
        identificadorUsuario: userId,
        productoOnboarding: product,
        productoOnboardingDetalle: detalleProducto,
        idFehaciente: reliableId,
        tiempoCompletarOnboarding: timeComplete,
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        onboardingPromoCode,
        tipoProceso,
        pasoProceso,
        detalleProceso,
        tipoUsuario: 'no cliente',
        intervinientes: isJointHolderAccount,
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: typeUserHolder,
        tipoOnboarding: investmentType,
        devId: '1RoboGBIPage',
    });
};

const recordCreditCardPage = (
    pathForTag,
    tipoProceso,
    pasoProceso,
    detalleProceso = '',
    recordId,
    userId,
    product,
    detalleProducto,
    promoCode = '',
    jointHolderAccount = [],
    reliableId = '',
    timeComplete = '',
    investmentType = ''
) => {
    const onboardingPromoCode = promoCode === '' ? 'sin codigo promocional' : promoCode;
    let isJointHolderAccount = jointHolderAccount.isJointHolderAccount ?? '';
    isJointHolderAccount = pathForTag === PATH_CONTACT ? '' : isJointHolderAccount;
    const typeHolder = jointHolderAccount.typeHolder ?? '';
    const typeUserHolder = jointHolderAccount.typeUserHolder ?? '';

    doTagging({
        nombrePagina: pathForTag,
        tipoPagina: PAGE_PRODUCT,
        estadoUsuario: 'logueado',
        idExpedienteOnboarding: recordId,
        identificadorUsuario: userId,
        productoOnboarding: product,
        productoOnboardingDetalle: detalleProducto,
        idFehaciente: reliableId,
        tiempoCompletarOnboarding: timeComplete,
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        onboardingPromoCode,
        tipoProceso,
        pasoProceso,
        detalleProceso,
        tipoUsuario: 'no cliente',
        intervinientes: isJointHolderAccount,
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: typeUserHolder,
        tipoOnboarding: investmentType,
        devId: '1CreditCardPage',
    });
};

const recordCreateNewClient = (
    recordId,
    userId,
    product,
    promoCode = '',
    reliableId = '',
    timeComplete = '',
    investmentType = '',
    jointHolderAccount
) => {
    const onboardingPromoCode = promoCode === '' ? 'sin codigo promocional' : promoCode;
    const dataProcess = getDataProcess(PATH_CREATE_NEW_CLIENT);
    const typeHolder = jointHolderAccount.typeHolder ?? '';

    doTagging({
        nombrePagina: PATH_CREATE_NEW_CLIENT,
        tipoPagina: PAGE_PRODUCT,
        estadoUsuario: 'logado',
        idExpedienteOnboarding: recordId,
        identificadorUsuario: userId,
        productoOnboarding: product,
        idFehaciente: reliableId,
        tiempoCompletarOnboarding: timeComplete,
        categoriaEvento: '',
        accionEvento: '',
        etiquetaEvento: '',
        onboardingPromoCode,
        tipoProceso: dataProcess.tipoProceso,
        pasoProceso: dataProcess.pasoProceso,
        detalleProceso: dataProcess.detalleProceso,
        tipoUsuario: 'no cliente',
        intervinientes: '',
        tipoTitular: typeHolder,
        tipoUsuarioInterviniente: '',
        devId: '1CreateNewClient',
        tipoOnboarding: investmentType,
        ...getGA4EventKeys({
            eventName: 'event_newCustomerCreation',
            pageName: '/onboarding/newCustomerCreation',
            processDetail: 'newCustomerCreation',
            onboardingType: investmentType,
            onboardingHolderType: holderTypes?.[typeHolder] ?? '',
        }),
    });
};

const recordPageError = (
    pageName,
    description,
    errorStatus,
    errorNumber,
    onboardingHolderType,
    investmentType,
    identificadorOnboarding = ''
) => {
    doTagging({
        tipoPagina: PAGE_ERROR,
        estadoUsuario: 'no logado',
        idExpedienteOnboarding: '',
        intervinientes: '',
        tipoTitular: '',
        tipoUsuarioInterviniente: '',
        descripcionError: description,
        devId: '1PageError',
        identificadorOnboarding,
        pageName: '/onboarding/error/relevantInformation',
        sectionFamily: SECTION_FAMILY,
        sectionCategory: SECTION_CATEGORY,
        sectionName: SECTION_NAME,
        interactionType: INTERACTION_TYPES.FUNNEL,
        serviceType: SERVICE_TYPE,
        processType: PROCESS_TYPE,
        processStep: 'error',
        processDetail: 'relevantInformation',
        onboardingHolderType,
        onboardingType: investmentType,
        errorCategory: pageName,
        errorDescription: description,
        errorStatus,
        errorNumber,
    });
};

const recordPromoCode = (eventTag, promoCode, investmentType = '') => {
    doTagging(
        {
            nombrePagina: PATH_OPEN_YOUR_ACCOUNT,
            tipoPagina: PAGE_INITIAL,
            estadoUsuario: 'no logado',
            idExpedienteOnboarding: '',
            identificadorUsuario: '',
            productoOnboarding: '',
            idFehaciente: '',
            tiempoCompletarOnboarding: '',
            categoriaEvento: EVENT_ONBOARDING,
            accionEvento: EVENT_ACTION_PROMO_CODE,
            etiquetaEvento: eventTag,
            onboardingPromoCode: promoCode,
            tipoProceso: '',
            pasoProceso: '',
            detalleProceso: '',
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            tipoOnboarding: investmentType,
            devId: '1PromoCode',
        },
        true
    );
};

const recordEventStepSuccess = (tipoOnboarding, accionEvento, etiquetaEvento, customData) => {
    recordEvent(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        tipoOnboarding,
        undefined,
        {
            categoriaEvento: ONBOARDING_SUCCESS,
            accionEvento,
            etiquetaEvento,
        },
        customData
    );
};

const recordEvent = (
    pathForTag,
    pageType,
    eventAction,
    eventTag,
    recordId = '',
    userId = '',
    idReliable = '',
    tipoOnboarding = '',
    identificadorOnboarding = '',
    customProcess = {},
    customData = {}
) => {
    const userState = pageType === PAGE_INITIAL || pageType === '' ? 'no logado' : 'logado';

    const isCustomEmpty = tools.isEmptyObject(customProcess);
    const dataProcess = isCustomEmpty
        ? { categoriaEvento: EVENT_ONBOARDING, accionEvento: eventAction, etiquetaEvento: eventTag }
        : customProcess;

    doTagging(
        {
            nombrePagina: pathForTag,
            tipoPagina: pageType,
            estadoUsuario: userState,
            idExpedienteOnboarding: recordId,
            identificadorUsuario: userId,
            productoOnboarding: '',
            idFehaciente: idReliable,
            tiempoCompletarOnboarding: '',
            categoriaEvento: dataProcess.categoriaEvento,
            accionEvento: dataProcess.accionEvento,
            etiquetaEvento: dataProcess.etiquetaEvento, //modelo de tarjeta seleccionada
            tipoOnboarding,
            onboardingPromoCode: dataProcess.onboardingPromoCode,
            tipoProceso: dataProcess.tipoProceso,
            pasoProceso: dataProcess.pasoProceso,
            detalleProceso: dataProcess.detalleProceso,
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            identificadorOnboarding,
            devId: '1recordEvent',
            ...customData,
        },
        true
    );
};
const recordEventCustomOnly = (customData, path = undefined) => {
    recordEvent(
        path,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        customData
    );
};

const recordCreditCardEvent = (
    pathForTag,
    pageType,
    eventCategory,
    eventAction,
    eventTag,
    recordId = '',
    idReliable = '',
    tipoOnboarding = ''
) => {
    const userState = pageType === PAGE_INITIAL || pageType === '' ? 'no logado' : 'logado';
    doTagging(
        {
            nombrePagina: pathForTag,
            tipoPagina: pageType,
            estadoUsuario: userState,
            idExpedienteOnboarding: recordId,
            productoOnboarding: '',
            idFehaciente: idReliable,
            tiempoCompletarOnboarding: '',
            categoriaEvento: eventCategory,
            accionEvento: eventAction,
            etiquetaEvento: eventTag,
            tipoOnboarding,
            onboardingPromoCode: '',
            detalleProceso: '',
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            devId: '1CreditCardEvent',
        },
        true
    );
};

const recordRoboGBIEvent = (
    pathForTag,
    pageType,
    eventCategory,
    eventAction,
    eventTag,
    recordId = '',
    userId = '',
    idReliable = '',
    tipoOnboarding = ''
) => {
    const userState = pageType === PAGE_INITIAL || pageType === '' ? 'no logado' : 'logado';
    doTagging(
        {
            nombrePagina: pathForTag,
            tipoPagina: pageType,
            estadoUsuario: userState,
            idExpedienteOnboarding: recordId,
            identificadorUsuario: userId,
            productoOnboarding: '',
            idFehaciente: idReliable,
            tiempoCompletarOnboarding: '',
            categoriaEvento: eventCategory,
            accionEvento: eventAction,
            etiquetaEvento: eventTag,
            tipoOnboarding,
            onboardingPromoCode: '',
            tipoProceso: '',
            pasoProceso: '',
            detalleProceso: '',
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            devId: '1RoboGBIEvent',
        },
        true
    );
};

const recordEventGdpr = (pathForTag, pageType, eventAction, eventTag, recordId = '', tipoOnboarding = '') => {
    const userState = pageType === PAGE_INITIAL || pageType === '' ? 'no logado' : 'logado';
    doTagging(
        {
            nombrePagina: pathForTag,
            tipoPagina: pageType,
            estadoUsuario: userState,
            idExpedienteOnboarding: recordId,
            identificadorUsuario: '',
            productoOnboarding: '',
            idFehaciente: '',
            tiempoCompletarOnboarding: '',
            categoriaEvento: 'interaccion clausulas GDPR',
            accionEvento: eventAction,
            etiquetaEvento: eventTag,
            tipoOnboarding,
            onboardingPromoCode: '',
            tipoProceso: '',
            pasoProceso: '',
            detalleProceso: '',
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            devId: '1EventGdpr',
        },
        true
    );
};

const recordError = (tagError, investmentType = '', eventCategoryTag = EVENT_ONBOARDING) => {
    doTagging(
        {
            nombrePagina: '',
            tipoPagina: '',
            estadoUsuario: '',
            idExpedienteOnboarding: '',
            identificadorUsuario: '',
            productoOnboarding: '',
            idFehaciente: '',
            tiempoCompletarOnboarding: '',
            categoriaEvento: eventCategoryTag,
            accionEvento: 'errores en formularios',
            etiquetaEvento: tagError,
            onboardingPromoCode: '',
            tipoProceso: '',
            pasoProceso: '',
            detalleProceso: '',
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            tipoOnboarding: investmentType,
            devId: '1recordError',
        },
        true
    );
};

const extractErrorFromObject = (errors, codes, descriptions) => {
    Object.keys(errors).map(key => {
        codes.push(key);
        descriptions.push(errors[key]);
    });

    return [codes, descriptions];
};

const errorTag = (errorObj, pathForTag, category = '', status = '', customErrorDescription = '') => {
    let [errorCodes, errorDescriptions] = [[], []];

    if (errorObj.errors) {
        [errorCodes, errorDescriptions] = extractErrorFromObject(errorObj.errors, errorCodes, errorDescriptions);
    } else if (errorObj.error) {
        errorCodes.push(errorObj.error);
        const descriptionToPush = customErrorDescription
            ? customErrorDescription
            : errorObj.errorDescription || errorObj.error_description;
        errorDescriptions.push(descriptionToPush);
    }

    recordPageError(pathForTag, category, errorCodes, status, errorDescriptions);
};

const recordCallMeBack = (loggedIn, step, detail, investmentType = '') => {
    const userState = loggedIn ? 'logado' : 'no logado';
    doTagging(
        {
            nombrePagina: window.utag_data.nombrePagina,
            tipoPagina: '',
            estadoUsuario: userState,
            idExpedienteOnboarding: '',
            identificadorUsuario: '',
            productoOnboarding: '',
            idFehaciente: '',
            tiempoCompletarOnboarding: '',
            categoriaEvento: '',
            accionEvento: '',
            etiquetaEvento: '',
            onboardingPromoCode: '',
            tipoProceso: 'call me back',
            pasoProceso: step,
            detalleProceso: detail,
            tipoUsuario: 'no cliente',
            intervinientes: '',
            tipoTitular: '',
            tipoUsuarioInterviniente: '',
            tipoOnboarding: investmentType,
            devId: '1callMeBack',
        },
        true
    );
};

const recordIdentityEvent = (
    categoriaEvento,
    accionEvento,
    etiquetaEvento,
    categoriaError = '',
    descripcionError = '',
    onboardingDocType = '',
    customData = {}
) => {
    return onboardingDocType === ''
        ? doTagging(
              {
                  categoriaEvento,
                  accionEvento,
                  etiquetaEvento,
                  categoriaError,
                  descripcionError,
                  devId: '1identityEvent',
                  ...customData,
              },
              true
          )
        : doTagging(
              {
                  categoriaEvento,
                  accionEvento,
                  etiquetaEvento,
                  categoriaError,
                  descripcionError,
                  onboardingDocType,
                  devId: '2identityEvent',
                  ...customData,
              },
              true
          );
};

const recordEventError = (
    categoriaEvento,
    accionEvento,
    etiquetaEvento,
    categoriaError = '',
    descripcionError = '',
    numeroError
) => {
    return doTagging(
        {
            categoriaEvento,
            accionEvento,
            etiquetaEvento,
            categoriaError,
            descripcionError,
            numeroError,
            devId: '1eventError',
        },
        true
    );
};

export default {
    recordEventError,
    recordedInitialPage,
    getRecordedInitialPage,
    recordedAddJointHoldersPage,
    getRecordedAddJointHoldersPage,
    recordedFinalizedIdentityVerification,
    recordedJointHoldersConfirmationPage,
    getRecordedJointHoldersConfirmationPage,
    getFinalizedIdentityVerification,
    recordedFinalizedContract,
    getFinalizedContract,
    recordedFinalized,
    getFinalized,
    recordInitialPage,
    recordPromoCode,
    recordPage,
    recordCreateNewClient,
    recordPageError,
    recordEvent,
    recordEventCustomOnly,
    recordEventGdpr,
    recordError,
    recordCallMeBack,
    recordRAPage,
    errorTag,
    recordRoboGBIPage,
    recordRoboGBIEvent,
    recordCreditCardEvent,
    recordCreditCardPage,
    getRecordedTestFailure,
    getRecordedTestSuccess,
    recordedTestFailure,
    recordedTestSuccess,
    getRecordedProfileInvestmentPlan,
    recordedProfileInvestmentPlan,
    recordEventStepSuccess,
    RELIABLE,
    PAGE_PRODUCT,
    PAGE_GENERIC,
    PAGE_INITIAL,
    PAGE_ERROR,
    VIDEOCALL_IDENTIFICATION,
    VIDEOSELFIE_IDENTIFICATION,
    recordIdentityEvent,
    recordedVideoSelected,
    getRecordedVideoSelected,
    ARES_PRODUCT_NAME,
    ARES_PRODUCT_ID,
    ARES_PRODUCT_CATEGORY,
    DOCUMENTATION_PRODUCT_NAME,
};
